export type BooleanString = 'true' | 'false' | '1' | '0' | 'yes' | 'no';

export function parseBoolean(value: BooleanString | boolean): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  return value === 'true' || value === '1' || value === 'yes';
}
